import * as React from "react";
import { forwardRef } from "react";
const SvgBaseline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-baseline-icon lucide-baseline", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 20h16" }), /* @__PURE__ */ React.createElement("path", { d: "m6 16 6-12 6 12" }), /* @__PURE__ */ React.createElement("path", { d: "M8 12h8" }));
const ForwardRef = forwardRef(SvgBaseline);
export { ForwardRef as ReactComponent };
